"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actor = void 0;
var Actor;
(function (Actor) {
    Actor["USER"] = "user";
    Actor["AUTOMATION"] = "automation";
})(Actor = exports.Actor || (exports.Actor = {}));
